import useSWRImmutable from "swr/immutable";
import { useWeb3React } from "@web3-react/core";
import VestPalm from "../../../../../abis/events/VestPalm.json";
import { contractFetcher } from "../../../../../lib/contracts";
import { getContract } from "../../../../../config/contracts";
import { useChainId } from "../../../../../lib/chains";
import { BigNumber } from "ethers";

export const useVestingConstants = (): {
  vestDuration: BigNumber | undefined;
  cliffPeriod: BigNumber | undefined;
} => {
  const { chainId } = useChainId();
  const { active, library } = useWeb3React();
  const contractAddress = getContract(chainId, "VestPalm");
  const { data: vestDuration } = useSWRImmutable<BigNumber>(
    [`VestPalm:VEST_DURATION:${active}`, chainId, contractAddress, "VEST_DURATION"],
    contractFetcher(library, VestPalm)
  );
  const { data: cliffPeriod } = useSWRImmutable<BigNumber>(
    [`VestPalm:CLIFF_PERIOD:${active}`, chainId, contractAddress, "CLIFF_PERIOD"],
    contractFetcher(library, VestPalm)
  );

  return {
    vestDuration,
    cliffPeriod,
  };
};
